module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_photogenic@2x-9483ba1b5ed77c9dd1fe04380ce5858a.webp";